import ErrorHandler from "./errorHandler";
import labels from "./errorLabels";

const {
  ERROR_PAGE: { NO_AUTH },
} = labels;

const NoAuth = () => {
  return <ErrorHandler errorCase={NO_AUTH} />;
};

export default NoAuth;
